import { AfterViewInit, Component, OnInit, Renderer2, OnDestroy } from '@angular/core';
import { FirebaseService } from "../../providers/firebase.service";
import { ActivatedRoute, Router } from "@angular/router";
import { PageSettings } from "../../models/pageSettings";
import { isUndefined, isNullOrUndefined } from "util";
import { Client } from "../../models/client";
import { ComponentSettings } from "../../models/componentSettings";
import { Login } from "../../models/login";
import { ScrollService } from "../../providers/scroll.service";
import { Portal } from '../../models/portal';
import { About } from '../../models/about';
import { Contact } from '../../models/contact';
import { environment } from '../../../environments/environment';
import { GeneralInfoSection } from '../../models/generalInfoSection';
import { AboutRow } from '../../models/aboutRow';

@Component({
  selector: 'app-page-settings',
  templateUrl: './page-settings.component.html',
  styleUrls: ['./page-settings.component.css']
})
export class PageSettingsComponent implements OnInit, AfterViewInit, OnDestroy {
  key: string;
  removeListener;

  clientData: Client;

  pageSettings: PageSettings;

  headerType: Array<any>;

  componentSettings: ComponentSettings;

  options = {
    key: environment.froalaKey,
    htmlRemoveTags: [],
    htmlExecuteScripts: false,
    pasteDeniedAttrs: [],
    htmlAllowedAttrs: ['accept', 'accept-charset', 'accesskey', 'action', 'align', 'allowfullscreen', 'allowtransparency', 'alt', 'aria-.*', 'async', 'autocomplete', 'autofocus', 'autoplay', 'autosave', 'background', 'bgcolor', 'border', 'charset', 'cellpadding', 'cellspacing', 'checked', 'cite', 'class', 'color', 'cols', 'colspan', 'content', 'contenteditable', 'contextmenu', 'controls', 'coords', 'data', 'data-.*', 'datetime', 'default', 'defer', 'dir', 'dirname', 'disabled', 'download', 'draggable', 'dropzone', 'enctype', 'for', 'form', 'formaction', 'frameborder', 'headers', 'height', 'hidden', 'high', 'href', 'hreflang', 'http-equiv', 'icon', 'id', 'ismap', 'itemprop', 'keytype', 'kind', 'label', 'lang', 'language', 'list', 'loop', 'low', 'max', 'maxlength', 'media', 'method', 'min', 'mozallowfullscreen', 'multiple', 'muted', 'name', 'novalidate', 'open', 'optimum', 'pattern', 'ping', 'placeholder', 'playsinline', 'poster', 'preload', 'pubdate', 'radiogroup', 'readonly', 'rel', 'required', 'reversed', 'rows', 'rowspan', 'sandbox', 'scope', 'scoped', 'scrolling', 'seamless', 'selected', 'shape', 'size', 'sizes', 'span', 'src', 'srcdoc', 'srclang', 'srcset', 'start', 'step', 'summary', 'spellcheck', 'style', 'tabindex', 'target', 'title', 'type', 'translate', 'usemap', 'value', 'valign', 'webkitallowfullscreen', 'width', 'wrap', 'onclick'],
    htmlAllowedTags: ['a', 'abbr', 'address', 'area', 'article', 'aside', 'audio', 'b', 'base', 'bdi', 'bdo', 'blockquote', 'br', 'button', 'canvas', 'caption', 'cite', 'code', 'col', 'colgroup', 'datalist', 'dd', 'del', 'details', 'dfn', 'dialog', 'div', 'dl', 'dt', 'em', 'embed', 'fieldset', 'figcaption', 'figure', 'footer', 'form', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'header', 'hgroup', 'hr', 'i', 'iframe', 'img', 'input', 'ins', 'kbd', 'keygen', 'label', 'legend', 'li', 'link', 'main', 'map', 'mark', 'menu', 'menuitem', 'meter', 'nav', 'noscript', 'object', 'ol', 'optgroup', 'option', 'output', 'p', 'param', 'pre', 'progress', 'queue', 'rp', 'rt', 'ruby', 's', 'samp', 'script', 'style', 'section', 'select', 'small', 'source', 'span', 'strike', 'strong', 'sub', 'summary', 'sup', 'table', 'tbody', 'td', 'textarea', 'tfoot', 'th', 'thead', 'time', 'tr', 'track', 'u', 'ul', 'var', 'video', 'wbr', 'script', 'style'],
  }

  reservationFollowUpOptions = [
    { label: 'Immediately', value: 'immediately' },
    { label: 'Day Before Reservation Expires', value: 'dayBeforeExpires' },
    { label: 'On Move-in Day', value: 'moveInDay' },
  ];

  aboutRowsLayoutOptions = [
    { label: 'Image/Video Left', value: 'imageLeft' },
    { label: 'Image/Video Right', value: 'imageRight' },
    { label: 'Stacked Image/Video Top', value: 'stackedImageTop' },
    { label: 'Stacked Image/Video Bottom', value: 'stackedImageBottom' },
    { label: 'Image/Video Only', value: 'imageOnly' },
    { label: 'HTML Only', value: 'htmlOnly' },
  ];

  constructor(
    public afService: FirebaseService,
    private router: Router,
    private route: ActivatedRoute,
    private scroll: ScrollService,
    private renderer: Renderer2,
  ) {
    this.headerType = [];
    this.headerType.push({ label: 'Video Slider', value: 'video' });
    this.headerType.push({ label: 'Picture Slider', value: 'slider' });
  }

  ngOnInit() {


    this.route.params.subscribe((params) => {
      this.key = params['key'];

      this.afService.getClientInfo(this.key).subscribe((clientData) => {
        this.clientData = clientData;

        this.afService.loadPageSettings(this.key).subscribe((data) => {
          if (isUndefined(data.$value)) {
            this.pageSettings = data;
            if (isUndefined(this.pageSettings.reserveAUnit.daysAReservationCanBeMadeInAdvance))
              this.pageSettings.reserveAUnit.daysAReservationCanBeMadeInAdvance = 7;

            if (isNullOrUndefined(this.pageSettings.reserveAUnit.disableDays)) {
              this.pageSettings.reserveAUnit.disableDays = [false, false, false, false, false, false, false];
            }

            if (isUndefined(this.pageSettings.login)) {
              this.pageSettings.login = new Login();
              this.savePageSettings();
            }

            if (isUndefined(this.pageSettings.portal)) {
              this.pageSettings.portal = new Portal();
              this.savePageSettings();
            }

            if (isUndefined(this.pageSettings.about)) {
              this.pageSettings.about = new About();
              this.savePageSettings();
            }

            if (isUndefined(this.pageSettings.contact)) {
              this.pageSettings.contact = new Contact();
              this.savePageSettings();
            }

            if (isUndefined(this.pageSettings.selectLocation)) {
              this.pageSettings.selectLocation = { blurb: null };
              this.savePageSettings();
            }

            if (isUndefined(this.pageSettings.storageCalculator)) {
              this.pageSettings.storageCalculator = { blurb: null };
              this.savePageSettings();
            }

            if (isUndefined(this.pageSettings.portableQuote)) {
              this.pageSettings.portableQuote = {
                showImages: false,
                showSliderArrows: false,
                sliderAutoPlay: true
              };
              this.savePageSettings();
            }

            if (isUndefined(this.pageSettings.reviews)) {
              this.pageSettings.reviews = {
                pageTitle: 'Reviews',
                metaTitle: 'Reviews | ' + this.clientData.name,
                metaDescription: `${ 'Read reviews from ' + this.clientData.name + ' customers.' }`
              };
              this.savePageSettings();
            }

            if (isUndefined(this.pageSettings.about.bannerImageUrl))
              this.pageSettings.about.bannerImageUrl = 'https://firebasestorage.googleapis.com/v0/b/prod-rocky-hill-storage.appspot.com/o/frame-100180.jpg?alt=media&token=aef8866f-a7fb-4f23-8fe7-921c7bb5aac7';

            if (isUndefined(this.pageSettings.privacyPolicy) || isNullOrUndefined(this.pageSettings.privacyPolicy.body)) {
              this.pageSettings.privacyPolicy = {
                showPrivacyPolicy: true,
                body: "<p><strong style=\"background-color: transparent; color: rgb(0, 60, 119);\">Privacy Policy</strong></p><p><span style=\"background-color: transparent; color: rgb(126, 126, 126);\">We respect and are committed to protecting your privacy. We may collect personally identifiable information when you visit our site. We also automatically receive and record information on our server logs from your browser including your IP address, cookie information and the page(s) you visited. We will not sell your personally identifiable information to anyone.</span></p><p><strong style=\"background-color: transparent; color: rgb(0, 60, 119);\">Security Policy</strong></p><p><span style=\"background-color: transparent; color: rgb(126, 126, 126);\">Your payment and personal information is always safe. Our Secure Sockets Layer (SSL) software is the industry standard and among the best software available today for secure commerce transactions. It encrypts all of your personal information, including credit card number, name, and address, so that it cannot be read over the internet.</span></p><p><strong style=\"background-color: transparent; color: rgb(31, 78, 121);\">Refund Policy</strong></p><p><span style=\"background-color: transparent; color: rgb(126, 126, 126);\">All payments are final and no refunds will be processed.</span></p><p><strong style=\"background-color: transparent; color: rgb(31, 78, 121);\">Shipping Policy (if applicable)</strong></p><p><span style=\"background-color: transparent; color: rgb(126, 126, 126);\">All items will ship within 2 business day of the order being placed.</span></p>"
              };
              this.savePageSettings();
            }

            if (isUndefined(this.pageSettings.gateCodeMinLength)) {
              this.pageSettings.gateCodeMinLength = 4;
              this.savePageSettings();
            }

            if (isUndefined(this.pageSettings.gateCodeMaxLength)) {
              this.pageSettings.gateCodeMaxLength = 10;
              this.savePageSettings();
            }

            if (isUndefined(this.pageSettings.viewUnits))
              this.pageSettings.viewUnits = { leftSide: {}, rightSide: {} };

            if (isUndefined(this.pageSettings.faqs))
              this.pageSettings.faqs = { leftColumn: [], rightColumn: [] };

            if (isUndefined(this.pageSettings.storageTips))
              this.pageSettings.storageTips = { leftColumn: [], rightColumn: [] };

            if (isUndefined(this.pageSettings.generalInfo))
              this.pageSettings.generalInfo = { sections: [] };

            if (isUndefined(this.pageSettings.title))
              this.pageSettings.title = 'Self Storage is Awesome';

            if (isUndefined(this.pageSettings.home.tabBoxViewRatesButtonText)) {
              this.pageSettings.home.tabBoxViewRatesButtonText = 'View Rates';
              this.savePageSettings();
            }

            if (isUndefined(this.pageSettings.home.tabBoxPayBillButtonText)) {
              this.pageSettings.home.tabBoxPayBillButtonText = 'Pay Bill';
              this.savePageSettings();
            }

            if (isUndefined(this.pageSettings.moveOutNoLogin)) {
              this.pageSettings.moveOutNoLogin = {
                title: 'Move Out Notice Form',
                blurb: `<p style="color:#FF0000;"><strong>Please note that you must vacate your storage unit on or before the last day of any calendar month. If you occupy your storage unit anytime on the 1st of the month, a full month’s payment is due. We are sorry, but early move-outs cannot be refunded and a late payment will result in a late fee.</strong></p>
        <p>*Tenant must also provide Owner written notice of their intention to terminate the Agreement at least ten (10) days prior to the end of the current rental period. Failure to provide ten (10) days written notice and vacate by the last day of any calendar month will result in tenant owing Owner one month's rent.</p>`
              };
            }

            if (isUndefined(this.pageSettings.sizeGuide.title))
              this.pageSettings.sizeGuide.title = 'What Size Do I Need?';

            if (isUndefined(this.pageSettings.sizeGuide.body))
              this.pageSettings.sizeGuide.body = 'Let us help you select the right unit for all your storage needs! <br>' +
                'Our Size Guide will help you easily determine the perfect size. <br>' +
                'Don’t hesitate to contact our storage professionals <br>' +
                'to answer any of your storage questions along the way.';

            if (isUndefined(this.pageSettings.rentAUnit)) {
              this.pageSettings.rentAUnit = {
                showAlternateContact: false,
                showCompanyName: false,
                showDateOfBirth: false,
                showCompanyPhone: false,
                rentUnitBlurb: '',
                requireSsn: false
              };
              this.savePageSettings();
            }
            else {
              if (isUndefined(this.pageSettings.rentAUnit.showCompanyName)) {
                this.pageSettings.rentAUnit = {
                  showAlternateContact: this.pageSettings.rentAUnit.showAlternateContact,
                  showCompanyName: false,
                  showDateOfBirth: false,
                  showCompanyPhone: false,
                  requireSsn: false
                };
                this.savePageSettings();
              }
              else if (isUndefined(this.pageSettings.rentAUnit.showDateOfBirth)) {
                this.pageSettings.rentAUnit = {
                  showAlternateContact: this.pageSettings.rentAUnit.showAlternateContact,
                  showCompanyName: this.pageSettings.rentAUnit.showCompanyName,
                  showDateOfBirth: false,
                  showCompanyPhone: false, requireSsn: false
                };
                this.savePageSettings();
              }
              else if (isUndefined(this.pageSettings.rentAUnit.showCompanyPhone)) {
                this.pageSettings.rentAUnit = {
                  showAlternateContact: this.pageSettings.rentAUnit.showAlternateContact,
                  showCompanyName: this.pageSettings.rentAUnit.showCompanyName,
                  showDateOfBirth: false,
                  showCompanyPhone: false,
                  alternateContactOptional: true,
                  licenseOptional: false,
                  requireSsn: false
                };
                this.savePageSettings();
              }
            }
          }
          else {
            this.pageSettings = new PageSettings(this.clientData.name);
            this.afService.savePageSettings(this.clientData, this.pageSettings).then((data) => {
              this.afService.openSnackBar('Page Settings Created');
            }).catch(e => {
              this.afService.openSnackBar(e.message);
            });
          }
        });

        this.afService.loadComponentSettings(this.key).subscribe((data) => {
          if (isUndefined(data.$value)) {
            this.componentSettings = data;
          }
          else {
            this.componentSettings = new ComponentSettings(this.clientData.name);
          }
        });

      });
    });

    this.removeListener = this.renderer.listen('window', 'keydown', (event: KeyboardEvent) => {
      if (event.ctrlKey && event.keyCode === 83) {
        this.afService.savePageSettings(this.clientData, this.pageSettings).then(() => {
          this.afService.openSnackBar('Page Settings Updated Successfully');
          this.afService.updateSettingsOnServer(this.clientData);
        }).catch(e => {
          this.afService.openSnackBar(e.message);
        });
      }
    });
  }

  removeAboutSlider(index) {
    this.pageSettings.about.aboutUsSliderUrls.splice(index, 1);
  }

  addAboutSlider() {
    if (typeof this.pageSettings.about.aboutUsSliderUrls === "undefined")
      this.pageSettings.about.aboutUsSliderUrls = [];
    this.pageSettings.about.aboutUsSliderUrls.push(null);
  }

  addAboutRow() {
    if (!this.pageSettings.about.rows) {
      this.pageSettings.about.rows = [];
    }
    this.pageSettings.about.rows.push(new AboutRow());
  }

  moveAboutRow(dir, index) {
    if (dir === 'up') {
      const swapIndex = index - 1;
      [this.pageSettings.about.rows[swapIndex], this.pageSettings.about.rows[index]] = [this.pageSettings.about.rows[index], this.pageSettings.about.rows[swapIndex]];
    }
    else {
      const swapIndex = index + 1;
      [this.pageSettings.about.rows[index], this.pageSettings.about.rows[swapIndex]] = [this.pageSettings.about.rows[swapIndex], this.pageSettings.about.rows[index]];
    }
  }

  removeAboutRow(index) {
    if (confirm('Are you sure?')) {
      this.pageSettings.about.rows.splice(index, 1);
      this.savePageSettings();
    }
  }

  addGeneralInfoSection() {
    if (!this.pageSettings.generalInfo.sections) {
      this.pageSettings.generalInfo.sections = [];
    }
    this.pageSettings.generalInfo.sections.push(new GeneralInfoSection());
  }

  removeGeneralInfoSection(index) {
    this.pageSettings.generalInfo.sections.splice(index, 1);
    this.savePageSettings();
  }

  createClassName(section) {
    section.className = section.title.replace(/\s+/g, '-').toLowerCase();
  }

  saveComponentSettings() {
    for (let tmp of this.componentSettings.features) {
      delete tmp._$visited;
    }

    for (let tmp of this.componentSettings.movingSupplies.itemsOffered) {
      delete tmp._$visited;
    }

    for (let tmp of this.componentSettings.maps.markers) {
      delete tmp._$visited;
    }

    this.afService.saveComponentSettings(this.clientData, this.componentSettings).then((data) => {
      this.afService.openSnackBar('Component Settings Updated.');
    }).catch(e => {
      this.afService.openSnackBar(e.message);
    })
  }

  ngAfterViewInit() {
    this.scroll.scrollToTop();
  }

  ngOnDestroy() {
    this.removeListener();
  }

  log() {
    console.log(this.pageSettings)
  }

  savePageSettings() {
    this.afService.savePageSettings(this.clientData, this.pageSettings).then(() => {
      this.afService.openSnackBar('Page Settings Updated Successfully');
    }).catch(e => {
      this.afService.openSnackBar(e.message);
    });
  }

  addPortableQuotePageSlider() {
    if (typeof this.pageSettings.portableQuote.sliderUrls === "undefined")
      this.pageSettings.portableQuote.sliderUrls = new Array<string>();
    this.pageSettings.portableQuote.sliderUrls.push(null);
  }

  removePortableQuotePageSlider(index) {
    this.pageSettings.portableQuote.sliderUrls.splice(index, 1);
  }

  goBack() {
    this.router.navigate(['../../'], { relativeTo: this.route });
  }
}



// WEBPACK FOOTER //
// ./src/ng2/app/admin-portal/page-settings/page-settings.component.ts